import reducer from './reducer'
import {
  login,
  logout,
  updateCurrentUser,
  activateAccount,
  setRole,
} from './actions'

export default {
  // Authentication status constants
  LOGGED_IN: 'LOGGED_IN',
  LOGGED_OUT: 'LOGGED_OUT',
  LOGGING_IN: 'LOGGING_IN',
  FIRST_LOGIN: 'FIRST_LOGIN',

  reducer,
  login,
  logout,
  updateCurrentUser,
  activateAccount,
  setRole,
}



// WEBPACK FOOTER //
// ./src/store/Auth/index.js